/**
 * Blank Stock Catalog — Style Configuration  v3
 * Asset: assets/blank-catalog-config.js
 *
 * Edit values below to customise appearance.
 * Colour values accept any valid CSS colour: '#rrggbb', 'rgb()', 'hsl()', etc.
 * Font names must match a font already loaded by your theme.
 * Size values are pixels — numbers only, no 'px' suffix.
 */

window.BSC_CONFIG = {

  /* ─── Fonts ─────────────────────────────────────────────────────────── */
  heading_font:           'inherit',   // catalog title
  body_font:              'inherit',   // everything else — uses your theme font

  /* ─── Top bar ───────────────────────────────────────────────────────── */
  topbar_bg:              '#ffffff',
  topbar_border:          '#e8e8e5',
  topbar_text:            '#1a1a1a',

  /* ─── Page background ───────────────────────────────────────────────── */
  page_bg:                '#f9f9f7',
  page_side_padding:      '16px',      // buffer on left and right edges
  card_image_height:      '200px',      // fixed height for all style card images

  /* ─── Style cards ───────────────────────────────────────────────────── */
  card_bg:                '#ffffff',
  card_border:            '#e8e8e5',
  card_radius:            '10',        // px — applied to style cards

  product_name_color:     '#1a1a1a',
  product_desc_color:     '#666666',
  product_meta_color:     '#999999',

  /* ─── Category filter buttons ───────────────────────────────────────── */
  filter_inactive_bg:     'transparent',
  filter_inactive_text:   '#666666',
  filter_inactive_border: '#dddddd',
  filter_active_bg:       '#1a1a1a',
  filter_active_text:     '#ffffff',

  /* ─── Section labels ────────────────────────────────────────────────── */
  section_label_color:    '#1a1a1a',   // category heading colour
  section_label_size:     '18',          // category heading size in px

  /* ─── Image placeholder ─────────────────────────────────────────────── */
  placeholder_bg:         '#f2f2f0',
  placeholder_color:      '#cccccc',

};
